import { type Html, html, View } from 'rune-ts';
import klass from './ProductSection.module.scss';
import { getResizedUrl } from '@services/MarppleShop/shared/util/image.ts';
import { map, pipe, toArray } from '@fxts/core';
import { font, staticFont } from '@services/MarppleShop/shared/typography';

export class ProductSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const images = [
      {
        url: '//s3.marpple.co/files/u_4648126/2025/6/original/97b2ce75e5d1c96c0912d40ff44fcfcf41d7e04b1.png',
        width: 295,
        img_klass: klass.img_1,
      },
      {
        url: '//s3.marpple.co/files/u_4648126/2025/6/original/995e74648c25cfe566839099ef7f9deec17c4ec98.png',
        width: 125,
        img_klass: klass.img_2,
      },
      {
        url: '//s3.marpple.co/files/u_4648126/2025/6/original/7659ad386a9e793685b46f0ea18404c6156361727.png',
        width: 909,
        img_klass: klass.img_3,
      },
      {
        url: '//s3.marpple.co/files/u_4648126/2025/6/original/b28ba35c2e056a29ef16275a5d0beb351cd4dad66.png',
        width: 246,
        img_klass: klass.img_4,
      },
      {
        url: '//s3.marpple.co/files/u_4648126/2025/6/original/1e9d04ded3297357c9c2614bc0c845fff78fe12a5.png',
        width: 280,
        img_klass: klass.img_5,
      },
      {
        url: '//s3.marpple.co/files/u_4648126/2025/6/original/7a10aae7253afe18a25ef4eb87486e48dd1702da4.png',
        width: 560,
        img_klass: klass.img_6,
      },
      {
        url: '//s3.marpple.co/files/u_4648126/2025/6/original/180fa034c80ec8bd6ebed3e9f61bee46228602b33.png',
        width: 328,
        img_klass: klass.img_7,
      },
      {
        url: '//s3.marpple.co/files/u_4648126/2025/6/original/e8e338c7682c25ac892f5594f0a0f4d22f32f1fa2.png',
        width: 334,
        img_klass: klass.img_8,
      },
    ];
    const text = {
      chapter: 'CHAPTER 1.',
      title: html.preventEscape(`굿즈 파트너스와 함께라면<br/> 전부 알아서 만들어줘요`),
    };

    return html`
      <section class="${klass.container}">
        <div class="${klass.title}">
          <div class="${staticFont('bebas_20_bold')}">${text.chapter}</div>
          <div class="${font('48_bold', '28_bold')}">${text.title}</div>
        </div>
        <div class="${klass.product_list}">
          <div class="${klass.marquee_wrapper}">
            <div class="${klass.marquee_background}">
              ${pipe(
                images,
                map(({ url, width, img_klass }) => {
                  return html`<img
                    src="${getResizedUrl({
                      url,
                      width: width * 2,
                      quality: 85,
                      format: 'webp',
                    })}"
                    class="${img_klass}"
                    alt="상품 이미지"
                  />`;
                }),
                toArray,
              )}
            </div>
            <div class="${klass.marquee_background}" aria-hidden="true">
              ${pipe(
                images,
                map(({ url, width, img_klass }) => {
                  return html`<img
                    src="${getResizedUrl({
                      url,
                      width: width * 2,
                      quality: 85,
                      format: 'webp',
                    })}"
                    class="${img_klass}"
                    alt="상품 이미지"
                  />`;
                }),
                toArray,
              )}
            </div>
          </div>
        </div>
      </section>
    `;
  }
}
